import { Button, Form, ListGroup, Stack, Badge, Modal } from "react-bootstrap";
import { MdCheck, MdClose, MdDelete, MdEdit, MdLink } from "react-icons/md";
import { FaBoxes } from "react-icons/fa";
import { useState, useEffect } from "react";
import { HttpData, HttpNoData } from "../../../../Core";
import AdditionMappingsModal from "./AdditionsMappingsModal";


export default function AdditionEdit({ addition, onDeleted, hideDelete, jwt }) {

    const [isEdit, setIsEdit] = useState(false);

    const [name, setName] = useState(addition.name);
    const [description, setDescription] = useState(addition.description);
    const [price, setPrice] = useState(addition.price);
    const [isForExport, setIsForExport] = useState(addition.isForExport || false);
    const [hasQuantity, setHasQuantity] = useState(addition.hasQuantity ?? false);

    const [mapping, setMapping] = useState(null);
    const [showMappingModal, setShowMappingModal] = useState(false);
    const [loadingMapping, setLoadingMapping] = useState(false);

    const [showLinkedProducts, setShowLinkedProducts] = useState(false);
    const [linkedProducts, setLinkedProducts] = useState([]);
    const [loadingLinked, setLoadingLinked] = useState(false);

    useEffect(() => {
        loadMapping();
    }, [addition.id]);

    const loadMapping = async () => {
        setLoadingMapping(true);
        try {
            const response = await HttpNoData(
                `/api/v1/additionmapping/by-source?sourceType=Standard&sourceAdditionId=${addition.id}`,
                "GET",
                jwt
            );
            if (response.statusSuccessful) {
                setMapping(response.data);
            } else {
                setMapping(null);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoadingMapping(false);
        }
    };

    const updateAsync = async () => {

        const sizesResponse = await HttpData(`/api/v1/calculateOrderCost/products/additions/${addition.id}`, 'PUT', jwt, {
            price: +price,
            name: name,
            description: description,
            isForExport: isForExport,
            hasQuantity: hasQuantity
        });

        if (sizesResponse.statusSuccessful) {
            addition.price = +price;
            addition.name = name;
            addition.description = description;
            addition.isForExport = isForExport;
            addition.hasQuantity = hasQuantity;
            setIsEdit(false);
        }
        else alert('Не получилось обновить')
    }

    const deleteAsync = async () => {

        const sizesResponse = await HttpNoData(`/api/v1/calculateOrderCost/products/additions/${addition.id}`, 'DELETE', jwt);

        if (sizesResponse.statusSuccessful)
            onDeleted();
        else alert('Не получилось удалить')
    }

    const handleMappingChanged = () => {
        loadMapping();
    };

    const openLinkedProducts = async () => {
        setShowLinkedProducts(true);
        setLoadingLinked(true);
        try {
            const response = await HttpNoData(
                `/api/v1/calculateOrderCost/products/additions/${addition.id}/linked-products`,
                'GET',
                jwt
            );
            setLinkedProducts(response.statusSuccessful ? (response.data ?? []) : []);
        } catch {
            setLinkedProducts([]);
        } finally {
            setLoadingLinked(false);
        }
    };

    if (isEdit)
        return <ListGroup.Item>
            <Form.Group className="mb-3">
                <Form.Label>Название</Form.Label>
                <Form.Control
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label>Цена</Form.Label>
                <Form.Control
                    value={price}
                    onChange={(e) => setPrice(e.target.value)}
                />
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label>Описание</Form.Label>
                <Form.Control
                    as={'textarea'}
                    rows={4}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                />
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Check
                    type="checkbox"
                    label="Участвует в выгрузке"
                    checked={isForExport}
                    onChange={(e) => setIsForExport(e.target.checked)}
                />
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Check
                    type="checkbox"
                    label="С количеством"
                    checked={hasQuantity}
                    onChange={(e) => setHasQuantity(e.target.checked)}
                />
            </Form.Group>
            <Stack direction="horizontal" gap={1}>
                <Button variant="success" onClick={updateAsync}>
                    <MdCheck />
                </Button>
                <Button variant="danger" onClick={() => setIsEdit(false)}>
                    <MdClose />
                </Button>
            </Stack>
        </ListGroup.Item>
    return <ListGroup.Item>
        <Form.Group className="mb-3">
            <Form.Label>Название</Form.Label>
            <Form.Control
                plaintext
                readOnly
                value={name}
                onChange={(e) => setName(e.target.value)}
            />
        </Form.Group>
        <Form.Group className="mb-3">
            <Form.Label>Цена</Form.Label>
            <Form.Control
                plaintext
                readOnly
                value={price}
                onChange={(e) => setPrice(e.target.value)}
            />
        </Form.Group>
        <Form.Group className="mb-3">
            <Form.Label>Описание</Form.Label>
            <Form.Control
                plaintext
                readOnly
                value={description}
                onChange={(e) => setDescription(e.target.value)}
            />
        </Form.Group>
        <Form.Group className="mb-3">
            <Form.Check
                type="checkbox"
                label="Участвует в выгрузке"
                checked={isForExport}
                disabled
                readOnly
            />
        </Form.Group>
        <Form.Group className="mb-3">
            <Form.Check
                type="checkbox"
                label="С количеством"
                checked={hasQuantity}
                disabled
                readOnly
            />
        </Form.Group>
        <div className="mb-3">
            <div className="d-flex justify-content-between align-items-center">
                <strong>Привязка к отправке:</strong>
                <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={() => setShowMappingModal(true)}
                    disabled={loadingMapping}
                >
                    <MdLink /> {mapping ? "Изменить" : "Привязать"}
                </Button>
            </div>
            {loadingMapping && <div className="text-muted">Загрузка...</div>}
            {!loadingMapping && mapping && (
                <Badge bg="info" className="mt-2">
                    {mapping.newProductName || `Отправка ID: ${mapping.newProductId}`}
                </Badge>
            )}
            {!loadingMapping && !mapping && (
                <div className="text-muted">Не привязано</div>
            )}
        </div>
        <Stack direction="horizontal" gap={1}>
            <Button variant="warning" onClick={() => setIsEdit(true)}>
                <MdEdit />
            </Button>
            <Button variant="info" size="sm" onClick={openLinkedProducts} title="Привязанные продукты">
                <FaBoxes />
            </Button>
            {!hideDelete && (
                <Button variant="danger" onClick={deleteAsync}>
                    <MdDelete />
                </Button>
            )}
        </Stack>

        <Modal show={showLinkedProducts} onHide={() => setShowLinkedProducts(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Продукты: {addition.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {loadingLinked && <div className="text-muted">Загрузка...</div>}
                {!loadingLinked && linkedProducts.length === 0 && (
                    <div className="text-muted">Не привязан ни к одному продукту</div>
                )}
                {!loadingLinked && linkedProducts.length > 0 && (
                    <ul className="mb-0">
                        {linkedProducts.map(p => <li key={p.id}>{p.name}</li>)}
                    </ul>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowLinkedProducts(false)}>Закрыть</Button>
            </Modal.Footer>
        </Modal>

        <AdditionMappingsModal
            show={showMappingModal}
            onHide={() => setShowMappingModal(false)}
            jwt={jwt}
            sourceAdditionId={addition.id}
            sourceType="Standard"
            onMappingChanged={handleMappingChanged}
        />

    </ListGroup.Item>
};